export function safeClone<T>(array: T[]): T[] {
  return [...(array ?? [])]
}

/**
 * Array vazio
 */
export const emptyArray: ReadonlyArray<any> = []

/**
 * Particiona um array em dois grupos baseado em um predicado.
 *
 * Itera sobre o array fornecido e separa os elementos em dois arrays distintos:
 * o primeiro contém os elementos que satisfazem o predicado, e o segundo contém
 * os elementos que não satisfazem.
 *
 * @template T - O tipo dos elementos no array
 * @param array - O array a ser particionado
 * @param predicate - Função que determina o critério de separação dos itens
 * @returns Uma tupla onde o primeiro elemento é o array com itens que satisfazem
 *          o predicado e o segundo elemento é o array com itens que não satisfazem
 */
export function partition<T>(array: T[], predicate: (item: T) => boolean): [T[], T[]] {
  const groupA: T[] = []
  const groupB: T[] = []

  for (const item of array) {
    if (predicate(item)) {
      groupA.push(item)
    } else {
      groupB.push(item)
    }
  }

  return [groupA, groupB]
}
